<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <pre-show-employee-form ref="showEmployeeModalForm" @ok="submitCallback" :disabled="disableSubmit" @handlerNextPage="handlerNextPage" ></pre-show-employee-form>
  </j-modal>
</template>

<script>

  import PreShowEmployeeForm from './PreShowEmployeeForm'
  export default {
    name: 'PreShowEmployeeModal',
    components: {
      PreShowEmployeeForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      handlerLastPage(lastModel) {
        this.visible=false
        this.$emit('handlerLastPage',lastModel)
      },

      handlerNextPage(model) {
        console.log('1111 handlerNextPage')
        this.visible=false
        this.$emit('handlerNextPage', model)
      },

      setModel(model) {
        console.log('PreEmployeeModel setModel : ',model)
        this.$nextTick(()=>{
          this.$refs.showEmployeeModalForm.setModel(model);
        })
      },
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.showEmployeeModalForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.showEmployeeModalForm.edit(record);
        })
      },
      show(id) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.showEmployeeModalForm.show(id);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.visible = false;
        this.$emit('ok');
        this.$refs.showEmployeeModalForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },

    }
  }
</script>